<iframe frameborder="0" class="object-cover" style="width: 100%; height: 90%;" [src]="transform(link.value)" type="text/html" allowscriptaccess="always" allowfullscreen="true" scrolling="yes" allownetworking="all"></iframe>

